import React from 'react';

import { Container } from './styled';

const CLSpinner = () => (
  <Container />
);

export default CLSpinner;
